import { MachineConfig } from 'xstate';

import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
  ProductBuilderMachineStateSchema,
} from '../../../types';
import { events } from './events';
import { states } from './states';

export const productBuilderMachineConfig: MachineConfig<
  ProductBuilderMachineContext,
  ProductBuilderMachineStateSchema,
  ProductBuilderMachineEvent
> = {
  id: 'productBuilder',
  initial: 'idle',
  on: {
    ...events,
  },
  states: {
    ...states,
  },
};
